/* tabObject.control_adapter.js */

var $ = require("jquery");
var _ = require("lodash");
var EventEmitter = require("events").EventEmitter;
var util = require("util");
var q = require("q");

var Conjurer = require("../Conjurer");
const StyleUtil = require("../StyleUtil");

/**
 * @event ObjectControlAdapter#ValueChanged
 * @type {Object}
 * @property oldValue {string} The previous value
 * @property newValue {string} The new value
 */

/**
 * @class ObjectControlAdapter
 * @classdesc renders an Object Jtype.
 * @implements ControlAdapterInterface
 *
 * @param $scope {$scope} The $scope object attached to the containingElement
 * @param logger {Bunyan} The logger
 * @param containingElem {DomElement} The containing dom element for this control
 * @param formCtrlDef {FormControlDefinition} The definition of this control object.
 *
 * @requires util
 * @requires EventEmitter
 *
 * @fires ObjectControlAdapter#ValueChanged
 */
module.exports = function TabObjectAdapter(logger, containingElem, formCtrlDef) {
    var self = this;
    var loadDeferred = q.defer();
    var _scope;
    //call Event Emitter Constructor
    EventEmitter.call(this);

    //The name of the control
    this.name = formCtrlDef.name;

    /**
     * @returns the data associated with this control.
     */
    this.getValue = function () {
        var val = formCtrlDef.value;
        //On initialization the child does not yet exist but thats ok as
        //the valueChanged events will handle this for us.
        if (_scope.ObjectRendererApi && _scope.ObjectRendererApi.getValue) {
            val = _scope.ObjectRendererApi.getValue();
        }
        // This is a hack to pull the array value from the editors.
        if (_.has(val, "@VALUE")) {
            val = val["@VALUE"];
        }
        return val;
    };

    /**
     * Set this controls current value.
     * @param val {string} The value to set this control to.
     * @returns the value associated with this control, it might not always be the same as the value passed in for
     * example adapters with a ValueScope.PARENT.
     */
    this.setValue = function (val, silent = true) {
        _scope.ObjectRendererApi.renderValues(val, silent);
    };

    this.getMultiEditActive = function () {
        return _scope.ObjectRendererApi.getMultiEditActive();
    };

    this.isInvalid = function () {
        return _scope.ObjectRendererApi ? _scope.ObjectRendererApi.isInvalid() : false;
    };

    this.getValidationMessages = function () {
        return _scope.ObjectRendererApi ? _scope.ObjectRendererApi.getValidationMessages() : [];
    };

    /**
     * Tear down this control
     */
    this.tearDown = function () {
        _scope.ObjectRendererApi.removeAllListeners();
        _scope.ObjectRendererApi.tearDown();
    };

    /**
     * A Hook to start the angular work, due to timing issues don't try anything angular is before this hook is called.
     * @param $scope
     */
    this.$init = function ($scope) {
        _scope = $scope;

        $scope.ObjectRendererSettings = {};

        var tabContainer = $(containingElem).children(".tab_container");

        let layoutCssClasses = _.get($scope, "jTypeContext.layout.container.cssClasses", []);
        //Setup directive
        var objectElem = $('<div class="nested_rendered_controls object_control"></div>');
        var objectRendererElem = $(
            '<gl-form-renderer class="object_renderer ' +
                layoutCssClasses.join(" ") +
                '" data-api="ObjectRendererApi" data-settings="ObjectRendererSettings"></gl-form-renderer>'
        );
        objectElem.append(objectRendererElem);
        tabContainer.append(objectElem);
        var tabForm = formCtrlDef;
        var tabLabel = tabForm.name;
        if (tabForm.configSettings.Display.label) {
            tabLabel = tabForm.configSettings.Display.label;
        } else if (tabForm.configSettings.Display.tab) {
            tabLabel = tabForm.configSettings.Display.tab;
        }

        $scope.tabName = formCtrlDef.configSettings.tabName;
        $scope.containerTabNum = formCtrlDef.configSettings.tabNum;
        $scope.tabInfo = {};
        $scope.tabLabel = tabLabel;
        $scope.tabInfo[$scope.tabName] = {};
        // Initialize the tab value
        $scope.tabInfo[$scope.tabName].currentTabNum = 0;

        $scope.tabSelected = function (tabNumber) {
            $scope.tabNum = tabNumber;
            $scope.$root.$broadcast("TabChange", {
                tabName: $scope.tabName,
                tabNum: tabNumber,
            });
        };

        // Listen for a tab change on the parent.
        var tabListenerCleanup = $scope.$on("TabChange", function (tabEvent, msg) {
            if ($scope.tabName === msg.tabName) {
                $scope.tabInfo[$scope.tabName].currentTabNum = msg.tabNum;
            }
        });

        $scope.$on("$destroy", function () {
            tabListenerCleanup();
        });

        let stylesConfig = _.get(formCtrlDef, "configSettings.Display.styles", {});
        StyleUtil.renderStylesConfig(stylesConfig, containingElem[0]);

        // Listen for a tab layout change
        // $scope.$on("TabLayoutChange", function (tabEvent, msg) {
        //     if (formCtrlDef.configSettings.tabName === msg.tabName) {
        //         $scope.tabLayout = msg.layout;
        //     }
        // })
        //Notify the world this adapter is ready to be compiled/linked and values retrieved
        self.emit("InitializationComplete", {
            initializedValue: self.getValue(),
        });
        return loadDeferred.promise;
    };
    /**
     * @type {Array.<String>}
     * @description $inject Annotation By adding the $inject property onto the init function the Angular
     * injection parameters can be specified.
     */
    this.$init.$inject = ["$scope"];

    /**
     * A Hook for when this control has been compiled/Linked.
     * @param $scope {$scope} The Angular Scope variable
     *
     * if $compiledAndLinked.$inject is specified those injection parameters will be used as the arguments
     */
    this.$compiledAndLinked = function ($scope, $rootScope) {
        $scope.ObjectRendererApi.on("ValueChanged", function (evt) {
            self.emit("ValueChanged", evt);
        });
        $scope.ObjectRendererApi.on("MultiEditActive", function (evt) {
            self.emit("MultiEditActive", evt);
        });
        $scope.ObjectRendererApi.on("Invalid", function (evt) {
            self.emit("Invalid", evt);
        });
        $scope.ObjectRendererApi.once("AllControlsLoaded", function (evt) {
            loadDeferred.resolve();
        });

        $rootScope.$broadcast("TabFormRendered", {
            tabName: $scope.tabName,
        });

        //Render the object
        let childObj = formCtrlDef.configSettings.value;
        // This is a hack so we can display editors
        if (_.isArray(childObj) && _.has(formCtrlDef.configSettings, "Display.editor")) {
            let display = _.cloneDeep(formCtrlDef.configSettings.Display);
            delete display.tab;
            // Create a mock configSettings.
            childObj = {
                "@": "@",
                Display: display,
                value: childObj,
                fieldType: "Array",
            };
        }
        $scope.ObjectRendererApi.render(childObj, {
            configurationData: formCtrlDef.configData,
            refInstances: formCtrlDef.refInstances,
            refTypes: formCtrlDef.refTypes,
            displayModeOptions: formCtrlDef.displayModeOptions,
        });
    };

    this.$compiledAndLinked.$inject = ["$scope", "$rootScope"];
};
//Make this API inherit from EventEmitter
util.inherits(module.exports, EventEmitter);

//Tell the Form renderer that this is an Angular Control.
module.exports.isAngularControl = true;
